// this one is to animated the text of a component by splitting them by words
"use client";

import { useMemo } from "react";
import { textContainerVariants, textWordVariants } from "@/app/utils/variants/textVariants";
import { motion } from "framer-motion";

type TextTag = "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

type Props = {
  text: string;
  as?: TextTag;
  className?: string;
  wordClassName?: string;
  inView?: boolean;

}


export function AnimatedText({ text, as: Tag = "p", className, wordClassName, inView = true }: Props) {
  const words = text.split(" ");
  const MotionTag = useMemo(() => motion(Tag), [Tag]);

  const containerVariants = textContainerVariants;
  const wordVariants = textWordVariants;
  return (
    <MotionTag
      className={className}
      variants={containerVariants}
      initial="hidden"
      whileInView={inView ? "visible" : undefined}
      animate={!inView ? "visible" : undefined}
      viewport={{ once: true, amount: 0.3 }}
    >
      {words.map((word, index) => (
        <motion.span
          key={index}
          variants={wordVariants}
          className={wordClassName}
          style={{ display: "inline-block", marginRight: "0.25em" }}
        >
          {word}
        </motion.span>
      ))}
    </MotionTag>
  );
};